import React from "react";
import { CarType } from "../../pages/auto-marketing/auto-marketing";
import { Box, Radio, Typography } from "@mui/material";
import { formatNumber } from "../../utils/utils.service";

interface CarItemProps {
  car: CarType;
  selectedVin: string;
  setSelectedVin: (vin: string) => void;
}

const CarItem: React.FC<CarItemProps> = ({ car, selectedVin, setSelectedVin }) => {
  return (
    <Box
      onClick={() => setSelectedVin(car.vinNumber || car.vin)}
      sx={{
        padding: "16px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        cursor: "pointer",
        width: "100%",
        borderRadius: "8px",
        border: `2px solid ${
          selectedVin === car.vinNumber || selectedVin === car.vin ? "#2B7FFF" : "#efefef"
        }`,
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: "16px", alignItems: "center" }}>
        <img
          alt={car.model}
          src={
            (car?.photoURL || car?.photo) && (car?.photoURL || car?.photo) !== "_NULL"
              ? car?.photoURL || car?.photo
              : "/images/car-placeholder.jpg"
          }
          width="80px"
          height="54px"
          style={{ borderRadius: "12px" }}
        />
        <Box>
          <Typography sx={{ fontSize: "16px", fontWeight: "600" }}>
            {car?.year} {car?.make} {car?.model}
          </Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#64748B" }}>
            Stock: {car?.stockNumber}
          </Typography>
          <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#64748B" }}>
            Vin: {car?.vinNumber || car?.vin}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "8px",
        }}
      >
        <Typography sx={{ fontSize: "12px", color: "#64748B" }}>
          ${" "}
          <span style={{ fontSize: "16px", fontWeight: "700" }}>
            {formatNumber((car?.priceOnWebsite || car?.price) ?? 0)}
          </span>
        </Typography>
        <Radio
          sx={{ padding: "0", "& .MuiSvgIcon-root": { fill: "#297EFF" } }}
          checked={selectedVin === car.vinNumber || selectedVin === car.vin}
          onChange={() => setSelectedVin(car.vinNumber || car.vin)}
        />
      </Box>
    </Box>
  );
};

export default CarItem;
